module.exports = __webpack_public_path__ + "img/store_control.2f9389f5.png";